var NavbarService = /** @class */ (function () {
    function NavbarService($http, $q, Util, Auth) {
        'ngInject';
        // hardcoded list of categories for navbar
        this.navbarCategories = [
            {
                'category': 'Acupuncture & Oriental Medicine',
                'taxonomyId': 301,
                'subCategory': [
                    {
                        'subCategory': 'Acupuncture Needles',
                        'taxonomyId': 302,
                    },
                    {
                        'subCategory': 'Acupuncture Supplies',
                        'taxonomyId': 304,
                    },
                    {
                        'subCategory': 'Asian Herbal Products',
                        'taxonomyId': 306,
                    },
                ],
            },
            {
                'category': 'Animal Health',
                'taxonomyId': 294,
                'subCategory': [
                    {
                        'subCategory': 'Animal Health',
                        'taxonomyId': 295,
                    },
                ],
            },
            {
                'category': 'Ayurvedic Formulas',
                'taxonomyId': 291,
                'subCategory': [
                    {
                        'subCategory': 'Ayurvedic Formulas',
                        'taxonomyId': 292,
                    },
                ],
            },
            {
                'category': 'Children’s Health',
                'taxonomyId': 287,
                'subCategory': [
                    {
                        'subCategory': 'Children’s Health',
                        'taxonomyId': 288,
                    },
                ],
            },
            {
                'category': 'Food & Beverage',
                'taxonomyId': 277,
                'subCategory': [
                    {
                        'subCategory': 'Food & Beverage',
                        'taxonomyId': 278,
                    },
                ],
            },
            {
                'category': 'Homeopathic Products',
                'taxonomyId': 271,
                'subCategory': [
                    {
                        'subCategory': 'Homeopathic Products',
                        'taxonomyId': 272,
                    },
                ],
            },
            {
                'category': 'Household Essentials',
                'taxonomyId': 268,
                'subCategory': [
                    {
                        'subCategory': 'Household Essentials',
                        'taxonomyId': 269,
                    },
                ],
            },
            {
                'category': 'Medical Supplies',
                'taxonomyId': 259,
                'subCategory': [
                    {
                        'subCategory': 'Medical Supplies',
                        'taxonomyId': 260,
                    },
                    {
                        'subCategory': 'Orthopedics',
                        'taxonomyId': 264,
                    },
                    {
                        'subCategory': 'Topical Products',
                        'taxonomyId': 265,
                    },
                ],
            },
            {
                'category': 'Nutritional Supplements',
                'taxonomyId': 1,
                'subCategory': [
                    {
                        'subCategory': 'Amino Acids',
                        'taxonomyId': 2,
                    },
                    {
                        'subCategory': 'Antioxidants',
                        'taxonomyId': 16,
                    },
                    {
                        'subCategory': 'CoQ10',
                        'taxonomyId': 25,
                    },
                    {
                        'subCategory': 'Enzymes',
                        'taxonomyId': 26,
                    },
                    {
                        'subCategory': 'Greens Powders',
                        'taxonomyId': 32,
                    },
                    {
                        'subCategory': 'Herbal Products',
                        'taxonomyId': 33,
                    },
                    {
                        'subCategory': 'Magnesium',
                        'taxonomyId': 42,
                    },
                    {
                        'subCategory': 'Medical Foods',
                        'taxonomyId': 44,
                    },
                    {
                        'subCategory': 'Omegas',
                        'taxonomyId': 50,
                    },
                    {
                        'subCategory': 'Phospholipids',
                        'taxonomyId': 60,
                    },
                    {
                        'subCategory': 'Probiotics',
                        'taxonomyId': 64,
                    },
                    {
                        'subCategory': 'Protein Powders',
                        'taxonomyId': 71,
                    },
                ],
            },
            {
                'category': 'Prescription Items (Rx)',
                'taxonomyId': 252,
                'subCategory': [
                    {
                        'subCategory': 'Injectable products',
                        'taxonomyId': 253,
                    },
                    {
                        'subCategory': 'Needles/Syringes',
                        'taxonomyId': 255,
                    },
                    {
                        'subCategory': 'Oral/Topical Rx',
                        'taxonomyId': 257,
                    },
                ],
            },
            {
                'category': 'Skin & Personal Care',
                'taxonomyId': 235,
                'subCategory': [
                    {
                        'subCategory': 'Skin & Personal Care',
                        'taxonomyId': 236,
                    },
                ],
            },
            {
                'category': 'Sports & Fitness',
                'taxonomyId': 231,
                'subCategory': [
                    {
                        'subCategory': 'Sports & Fitness',
                        'taxonomyId': 232,
                    },
                ],
            },
            {
                'category': 'Vitamins & Minerals',
                'taxonomyId': 196,
                'subCategory': [
                    {
                        'subCategory': 'Magnesium',
                        'taxonomyId': 42,
                    },
                    {
                        'subCategory': 'Minerals',
                        'taxonomyId': 197,
                    },
                    {
                        'subCategory': 'Multivitamins',
                        'taxonomyId': 213,
                    },
                    {
                        'subCategory': 'Vitamins',
                        'taxonomyId': 219,
                    },
                ],
            },
        ];
        this.$http = $http;
        this.$q = $q;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.Auth = Auth;
    }
    NavbarService.prototype.getContent = function (id) {
        var request = this.$http({
            method: 'get',
            url: 'api/content/' + id
        });
        return request.then(function (data) {
            if (data) {
                return data;
            }
        }, function () { return {}; });
    };
    /**
     * get featured products for the navbar shop menu
     * @return {promise}
     */
    NavbarService.prototype.getFeaturedProducts = function () {
        var _this = this;
        return this.$http.get('api/products/featured', { params: { section: 'shopMenu' } })
            .then(function (response) {
            if (response.data && response.data.response) {
                return response.data.response;
            }
        })
            .catch(function (error) {
            return _this.$q.reject(error);
        });
    };
    NavbarService.prototype.getFeaturedShopMenuBrands = function () {
        var request = this.$http({
            method: 'get',
            url: 'api/products/brands/featured',
            params: {
                'section': 'shopmenu'
            }
        });
        return (request.then(function (response) {
            if (response.data && response.data.response) {
                return response.data.response;
            }
        }, this.handleError));
    };
    NavbarService.prototype.getFeaturedMegaMenuBrands = function () {
        var request = this.$http({
            method: 'get',
            url: 'api/products/brands/featured',
            params: {
                'section': 'megamenu',
            },
        });
        return (request.then(function (response) {
            if (response.data && response.data.response) {
                return response.data.response;
            }
        }, this.handleError));
    };
    NavbarService.prototype.getBlog = function () {
        var request = this.$http({
            method: 'get',
            url: '/api/content/resourceContentFile/blog'
        });
        return (request.then(function (response) {
            return response.data;
        }, this.handleError));
    };
    NavbarService.prototype.getFrequentlyOrderedItems = function () {
        var _this = this;
        var deferred = this.$q.defer();
        this.Auth.checkForLogin()
            .then(function (data) {
            if (data) {
                var request = _this.$http({
                    method: 'get',
                    url: 'api/account/orders/frequentlyordered'
                });
                return (request.then(function (response) {
                    if (response.data && response.data.response) {
                        return deferred.resolve(response.data.response);
                    }
                }, _this.handleError));
            }
        });
        return deferred.promise;
    };
    NavbarService.prototype.getSupportKey = function () {
        var request = this.$http({
            method: 'get',
            url: 'api/account/supportkey'
        });
        return (request.then(function (response) {
            if (response.data) {
                return response.data;
            }
        }, this.handleError));
    };
    NavbarService.prototype.getEducation = function () {
        return this.getContent(9009);
    };
    NavbarService.prototype.getWellevate = function () {
        return this.getContent(9000);
    };
    NavbarService.prototype.getQuality = function () {
        return this.getContent(9010);
    };
    NavbarService.prototype.getShopQuality = function () {
        return this.getContent(9019);
    };
    return NavbarService;
}());
export default NavbarService;
//# sourceMappingURL=navbar.service.js.map